// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Belt_Array = require("@rescript/runtime/lib/js/Belt_Array.js");

function useReducer(initialState, reducer) {
  let match = React.useReducer((fullState, action) => {
    let state = reducer(fullState.state, action);
    if (typeof state !== "object") {
      return fullState;
    } else if (state.TAG === "Update") {
      return {
        state: state._0,
        sideEffects: fullState.sideEffects
      };
    } else {
      return {
        state: state._0,
        sideEffects: {
          contents: Belt_Array.concat(fullState.sideEffects.contents, [state._1])
        }
      };
    }
  }, {
    state: initialState,
    sideEffects: {
      contents: []
    }
  });
  let dispatch = match[1];
  let match$1 = match[0];
  let sideEffects = match$1.sideEffects;
  let state = match$1.state;
  React.useEffect(() => {
    if (sideEffects.contents.length !== 0) {
      Belt_Array.forEach(sideEffects.contents, fn => fn({
        state: state,
        dispatch: dispatch
      }));
      sideEffects.contents = [];
    }
  }, [sideEffects.contents]);
  return [
    state,
    dispatch
  ];
}

exports.useReducer = useReducer;
/* react Not a pure module */
